import Chart from 'chart.js/auto';

hp(window).on('load', () => {
    const colors = {
        red: 'rgb(255, 51, 51)',
        red50: 'rgba(255, 51, 51, 0.3)',
        red25: 'rgba(255, 51, 51, 0.18)',
        yellow: 'rgb(255, 170, 51)',
        yellow50: 'rgba(255, 170, 51, 0.3)',
        yellow25: 'rgba(255, 170, 51, 0.18)',
        green: 'rgb(13, 180, 97)',
        green50: 'rgba(0, 204, 102, 0.3)',
        green25: 'rgba(0, 204, 102, 0.18)',
        white: 'rgb(255, 255, 255)',
        black: 'rgb(9, 9, 9)'
    }

    const chartData = {
        'FCP': 10,
        'LCP': 20,
        'TBT': 20,
        'CLS': 20,
        'SI': 10,
    }

    const chartResultData1 = {
        'FCP': 5,
        'LCP': 16,
        'TBT': 16,
        'CLS': 16,
        'SI': 5,
    }

    const chartResultData2 = {
        'FCP': 9,
        'LCP': 19,
        'TBT': 19,
        'CLS': 18,
        'SI': 9,
    }

    let calculatePercentage = (numMax, numCurrent) => {
        return (numCurrent / numMax) * 100;
    }

    let getColor = (percentage, halfColor = false, ghostColor = false) => {
        let colorName = 'green';

        if (percentage < 50) {
            colorName = 'red'
        } else if (percentage < 90) {
            colorName = 'yellow'
        }

        if (halfColor && ghostColor) {
            colorName = colorName + '25'
        }

        if (halfColor && !ghostColor) {
            colorName = colorName + '50'
        }


        return colors[colorName];
    }

    const data = {
        chartResultData: chartResultData1,
        datasets: [{
            data: [
                chartData.FCP,
                chartData.LCP,
                chartData.TBT,
                chartData.CLS,
                chartData.SI,
            ],
            backgroundColor: [
                getColor(calculatePercentage(chartData.FCP, chartResultData1.FCP), true),
                getColor(calculatePercentage(chartData.LCP, chartResultData1.LCP), true),
                getColor(calculatePercentage(chartData.TBT, chartResultData1.TBT), true),
                getColor(calculatePercentage(chartData.CLS, chartResultData1.CLS), true),
                getColor(calculatePercentage(chartData.SI, chartResultData1.SI), true),
            ],
            borderColor: [
                getColor(calculatePercentage(chartData.FCP, chartResultData1.FCP), true),
                getColor(calculatePercentage(chartData.LCP, chartResultData1.LCP), true),
                getColor(calculatePercentage(chartData.TBT, chartResultData1.TBT), true),
                getColor(calculatePercentage(chartData.CLS, chartResultData1.CLS), true),
                getColor(calculatePercentage(chartData.SI, chartResultData1.SI), true),
            ],
            borderWidth: 1,
            borderRadius: 20,
            cutout: '90%',
            offset: 8,
        }]
    };

    const data2 = {
        chartResultData: chartResultData2,
        datasets: [{
            data: [
                chartData.FCP,
                chartData.LCP,
                chartData.TBT,
                chartData.CLS,
                chartData.SI,
            ],
            backgroundColor: [
                getColor(calculatePercentage(chartData.FCP, chartResultData2.FCP), true),
                getColor(calculatePercentage(chartData.LCP, chartResultData2.LCP), true),
                getColor(calculatePercentage(chartData.TBT, chartResultData2.TBT), true),
                getColor(calculatePercentage(chartData.CLS, chartResultData2.CLS), true),
                getColor(calculatePercentage(chartData.SI, chartResultData2.SI), true),
            ],
            borderColor: [
                getColor(calculatePercentage(chartData.FCP, chartResultData2.FCP), true),
                getColor(calculatePercentage(chartData.LCP, chartResultData2.LCP), true),
                getColor(calculatePercentage(chartData.TBT, chartResultData2.TBT), true),
                getColor(calculatePercentage(chartData.CLS, chartResultData2.CLS), true),
                getColor(calculatePercentage(chartData.SI, chartResultData2.SI), true),
            ],
            borderWidth: 1,
            borderRadius: 20,
            cutout: '90%',
            offset: 8,
        }]
    };

    const customDataLabels = {
        id: 'customDataLabels',
        afterDatasetsDraw(chart, args, pluginOptions) {
            const { ctx, data, options, chartArea: { top, right, bottom, left, width, height } } = chart;

            ctx.save()
            const halfWidth = width / 2 + left;
            const halfHeight = height / 2 + top;

            data.datasets[0].data.forEach((num, index) => {
                const { x, y } = chart.getDatasetMeta(0).data[index].tooltipPosition()
                const text = Object.keys(chartData)[index]

                ctx.font = 'bold 12px sans-serif'
                ctx.fillStyle = colors.black
                ctx.textAlign = 'center'
                ctx.textBaseline = 'middle'

                const extraLineWidth = 5

                const xLine = x >= halfWidth ? x + extraLineWidth : x - extraLineWidth;
                const yLine = y >= halfHeight ? y + 25 : y - 25;
                const extraLine = x >= halfWidth ? extraLineWidth : -extraLineWidth;
                const textWidth = ctx.measureText(text).width;
                const textWidthPosition = x >= halfWidth ? textWidth : -textWidth;

                // ctx.strokeStyle = colors.white
                // ctx.beginPath()
                // ctx.moveTo(x,y)
                // ctx.lineTo(xLine, yLine)
                // ctx.lineTo(xLine + extraLine, yLine)
                // ctx.stroke()

                ctx.fillText(text, xLine + extraLine + textWidthPosition, yLine)
            })
        }
    }

    const doughnutLabel = {
        id: 'doughnutLabel',
        beforeDatasetsDraw(chart, args, pluginOptions) {
            const { ctx, data, options, chartArea: { top, right, bottom, left, width, height }, } = chart;
            const chartResultData = data.chartResultData
            let total = 0
            let maxTotal = 0

            Object.keys(chartResultData).forEach(key => {
                total += chartResultData[key]
                maxTotal += chartData[key]
            })

            const padding = options.layout.padding
            const { x, y, innerRadius, outerRadius } = chart.getDatasetMeta(0).data[0]
            const radius = ((innerRadius + outerRadius) / 2) - (padding / 4)

            ctx.save()

            const percentage = calculatePercentage(maxTotal, total)


            ctx.beginPath()
            ctx.fillStyle = getColor(percentage, true, true)
            ctx.arc(x, y, radius, 0, 2 * Math.PI, false)
            ctx.fill()

            ctx.fillStyle = getColor(percentage)
            ctx.font = 'bold 3rem sans-serif'
            ctx.textAlign = 'center'
            ctx.textBaseline = 'middle'
            ctx.fillText(`${Math.floor(percentage)}`, x, y)
        }
    }

    const doubleArcs = {
        id: 'doubleArcs',
        afterDatasetsDraw(chart, args, pluginOptions) {
            const { ctx, data } = chart;
            const cutout = parseInt(data.datasets[0].cutout)
            const angleOffset = data.datasets[0].offset;
            const radianAngleOffset = (angleOffset / 2) * Math.PI / 180
            const dataBorderWidth = data.datasets[0].borderWidth;
            const chartResultData = data.chartResultData;

            ctx.save();
            Object.keys(chartData).forEach((key, index) => {
                const { x, y, outerRadius, startAngle, endAngle } = chart.getDatasetMeta(0).data[index]
                const borderWidth = (cutout / 100) * 0.05 * outerRadius * 2;
                const lineWidth = borderWidth + dataBorderWidth * 2;
                const percentage = calculatePercentage(chartData[key], chartResultData[key])

                const radius = outerRadius - (borderWidth / 2) + dataBorderWidth;
                const realEndAngle = (startAngle + (((endAngle - startAngle) * percentage) / 100)) - radianAngleOffset;
                const realStartAngle = startAngle + radianAngleOffset;

                ctx.strokeStyle = getColor(percentage);
                ctx.lineWidth = lineWidth
                ctx.lineCap = "round";

                ctx.beginPath()
                ctx.arc(x, y, radius, realStartAngle, realEndAngle, false)
                ctx.stroke();
            })
        }
    }

    const angleLabels = {
        id: 'angleLabels',
        beforeDatasetsDraw(chart, args, pluginOptions) {
            const { data, tooltip } = chart

            const chartNames = Object.keys(chartData)
            const chartResultData = data.chartResultData

            tooltip.options.callbacks.label = (item) => {
                const index = item.dataIndex
                const label = chartNames[index]
                const value = chartResultData[label]
                const maxValue = chartData[label];


                return `${label}: ${value}/${maxValue}`
            }
        }
    }

    const config = {
        type: 'doughnut',
        data,
        options: {
            layout: {
                padding: 50,
            },
            plugins: {
                legend: {
                    display: false
                }
            },
        },
        plugins: [customDataLabels, doughnutLabel, doubleArcs, angleLabels]
    };

    const config2 = {
        type: config.type,
        data: data2,
        options: config.options,
        plugins: config.plugins
    };

    let isIntersecting = false

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !isIntersecting) {
                isIntersecting = true

                new Chart(document.getElementById('donut'), config);
                new Chart(document.getElementById('donut2'), config2);
            }
        });
    }, {
        threshold: 0.5,
    });

    observer.observe(document.querySelector('.site-speed-test-section'));
})
